module.exports = __webpack_public_path__ + "img/ZB网关.da37a7ec.jpg";